<template>
  <div class="flex flex-row flex-nowrap">
    <input
      v-model="internalValue"
      :type="inputType"
      :class="inputClass"
      class="flex-auto basis-0 min-w-0"
      v-bind="$attrs"
      @focus="handleFocus"
    />
    <component
      :is="eyeType"
      @click="toggleReveal"
      class="flex-none mx-2 mt-1.5 mb-4"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  inputClass: {
    type: [String, Object, Array],
    default: ''
  }
});

const emit = defineEmits(['update:modelValue', 'focus']);

const reveal = ref(false);

const internalValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value);
  }
});

const inputType = computed(() => (reveal.value ? "text" : "password"));

const eyeType = computed(() => (reveal.value ? "eye-off-icon" : "eye-icon"));

const toggleReveal = () => {
  reveal.value = !reveal.value;
};

const handleFocus = () => {
  emit('focus');
};
</script>


<style scoped>
</style>